<div [classList]="modalBodyClass">
  <p [innerHtml]="modalBody | translate"></p>
</div>
